import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import PageHeader from '../../header';
import CenterPanel from './centerPanel';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import { getMeetingRoomUsers } from '../../../../actions/user';
import { hideWhenClickAwayOrResize } from '../../../shared/contextualMenu/content';
import {
  getMeetingRoomWithSearchTerm,
  getAvailableRolesforMeetingRoom,
  selectMeetingRoom,
  selectMeetingRoomId,
  updateMeetingRoomMemberSearch,
} from 'actions/meetingRoom.js';
import MeetingRoomAddUsersModal from './addUserModal';
import ManageRolesForUsersModal from 'containers/MeetingRoomManageUsersRolesModal';
import { previousPage } from 'actions/navigationBar';

export default function MeetingRoomManageUsersContent(props) {
  const dispatch = useDispatch();
  const [fetchingUserICanManage, setFetchingUserICanManage] = useState(false);

  const cb = () => {
    let cbForGetUsers = () => {
      dispatch(
        getAvailableRolesforMeetingRoom(props.id, () => {
          dispatch(selectMeetingRoom(props.selectedMeetingRoom));
          setFetchingUserICanManage(false);
        })
      );
    };
    dispatch(getMeetingRoomUsers(props.id, cbForGetUsers));
  };

  useEffect(() => {
    setFetchingUserICanManage(true);
    dispatch(selectMeetingRoomId(props.id));
    dispatch(getMeetingRoomWithSearchTerm(props.id, cb));

    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));

    return () => {
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
      dispatch(updateMeetingRoomMemberSearch(''));
    };
  }, []);

  const onSearchTermInputChange = (e) => {
    if (e.target != undefined) dispatch(updateMeetingRoomMemberSearch(e.target.value));
    else dispatch(updateMeetingRoomMemberSearch(e));
  };

  const isMeetingRoomLoaded = props.selectedMeetingRoom && props.selectedMeetingRoom.id > 0;
  let bottomSession = <AccordionSession selectedMeetingRoom={props.selectedMeetingRoom} userId={props.userId} />;

  let modals = (
    <div>
      {props.showMeetingRoomAddUsersModal ? (
        <MeetingRoomAddUsersModal
          selectedMeetingRoom={props.selectedMeetingRoom}
          addUsersForm={props.addUsersForm}
          availableRoles={props.availableRoles}
        />
      ) : (
        ''
      )}

      {props.showMeetingRoomManageUsersRolesModal && (
        <ManageRolesForUsersModal
          usersIcanManage={props.usersIcanManage}
          selectedMeetingRoom={props.selectedMeetingRoom}
          availableRoles={props.availableRoles}
        />
      )}
    </div>
  );

  return (
    <div>
      <div className="main-ui-container waiting-area-view-one new-waiting-area-view-one">
        <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
          <div className="left-hand-side-panel">
            <div className="relative">
              <PageHeader
                classes="waiting-area-title"
                subHeaderClass="waiting-area-sub-title"
                title={APP.LANGUAGE.MeetingRoomManageUsers.PageHeaderTitle}
                subHeader={
                  props.selectedMeetingRoom.name != undefined && props.selectedMeetingRoom.name
                    ? APP.LANGUAGE.MeetingRoomManageUsers.PageSubHeaderTitle.replace(
                        '##meetingRoomName##',
                        props.selectedMeetingRoom.name.trim()
                      ).replace('##organisationName##', props.selectedMeetingRoom.organisationAbbreviatedName.trim())
                    : 'Loading...'
                }
                notRenderLogo={true}
                linkTo={
                  props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? `/organisational-unit/view-all`
                    : `/meeting-room/view-all`
                }
                linkText={
                  props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                    : APP.LANGUAGE.MeetingRoomManageUsers.BackToMeetingRoomsLinkText
                }
                linkOnClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.MeetingRoomManageUsers.PageHeaderTitle));
                }}
                linkClass={
                  props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? 'back-to-org-link'
                    : 'back-to-mr-link'
                }
                showLinkCondition={isMeetingRoomLoaded}
              >
                <span>
                  <img
                    className="ui image  mrrnull fl pdrs header-icon mrtsss"
                    src={APP.IMAGES.MeetingRoomIcon.default}
                  />
                </span>
              </PageHeader>
            </div>
            <div className="manage-users-meeting-room-container pdlm pdrm">
              <CenterPanel
                searchTerm={props.searchTerm}
                usersIcanManage={props.usersIcanManage}
                onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
                fetchingUserICanManage={fetchingUserICanManage}
                timezone={props.timezone}
                isOnMobileOrTablet={false}
                selectedMeetingRoom={props.selectedMeetingRoom}
              />
            </div>
          </div>

          <div className="right-hand-side-panel color-right-hand-side-panel-bg">
            <RightPanelOrTopPanel
              bottomSession={bottomSession}
              fetchingUserICanManage={fetchingUserICanManage}
              usersIcanManage={props.usersIcanManage}
              selectedMRUsersEmail={props.selectedMRUsersEmail}
              previousPage={props.previousPage}
              meetingRoomName={props.selectedMeetingRoom.name}
            />
          </div>
        </Container>
        <Container fluid as={Media} lessThan="computer">
          <div className="left-hand-side-panel-mobile">
            <PageHeader
              classes="waiting-area-title"
              subHeaderClass="waiting-area-sub-title"
              title={APP.LANGUAGE.MeetingRoomManageUsers.PageHeaderTitle}
              subHeader={
                props.selectedMeetingRoom.name != undefined && props.selectedMeetingRoom.name
                  ? APP.LANGUAGE.MeetingRoomManageUsers.PageSubHeaderTitle.replace(
                      '##meetingRoomName##',
                      props.selectedMeetingRoom.name.trim()
                    ).replace('##organisationName##', props.selectedMeetingRoom.organisationAbbreviatedName.trim())
                  : 'Loading...'
              }
              notRenderLogo={true}
              linkTo={`/organisational-unit/view-all`}
              linkText={APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}
              linkOnClick={() => {
                dispatch(previousPage(APP.LANGUAGE.MeetingRoomManageUsers.PageHeaderTitle));
              }}
              showLinkCondition={isMeetingRoomLoaded}
            >
              <span>
                <img
                  className="ui image  mrrnull fl pdrs header-icon mrtsss"
                  src={APP.IMAGES.MeetingRoomIcon.default}
                />
              </span>
            </PageHeader>
            <div className="right-hand-side-panel-mobile">
              <RightPanelOrTopPanel
                fetchingUserICanManage={fetchingUserICanManage}
                usersIcanManage={props.usersIcanManage}
                selectedMRUsersEmail={props.selectedMRUsersEmail}
                previousPage={props.previousPage}
                dispatch={props.dispatch}
                meetingRoomName={props.selectedMeetingRoom.name}
              />
            </div>
            <div className="pdlm pdrl">
              <CenterPanel
                searchTerm={props.searchTerm}
                usersIcanManage={props.usersIcanManage}
                onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
                fetchingUserICanManage={fetchingUserICanManage}
                timezone={props.timezone}
                isOnMobileOrTablet={false}
                selectedMeetingRoom={props.selectedMeetingRoom}
                dispatch={props.dispatch}
              />
            </div>
            <div className="mrtl right-hand-side-bottom-on-mobile">
              {bottomSession}
              <BottomLogo />
            </div>
          </div>
        </Container>
        {modals}
      </div>
    </div>
  );
}

MeetingRoomManageUsersContent.propTypes = {
  id: PropTypes.number,
  selectMeetingRoom: PropTypes.object,
  usersIcanManage: PropTypes.array.isRequired,
  searchTerm: PropTypes.string,
  availableRoles: PropTypes.array,
  dispatch: PropTypes.func,
};
